import { Box, Typography } from "@mui/material";

import NoResultsImg from "@app/analytics/assets/no_results.png";
import ROUTES from "@app/common/routes";

import { Link } from "@rui/Link";
import Stack from "@rui/Stack";
import { Bold } from "@rui/styles";

const NoResults = ({ query }: { query: string }) => (
  <Stack variant="center" sx={{ height: "100%", p: 3 }} spacing={1}>
    <Box component="img" src={NoResultsImg} sx={{ height: "200px" }} />
    <Typography sx={{ color: "shades.neutral.800" }}>
      Sorry, we couldn't find any results for <Bold>{query}</Bold>
    </Typography>
    <Typography variant="bodySecondaryReg" sx={{ color: "shades.neutral.500" }}>
      Try searching with another term, or return to{" "}
      <Link to={ROUTES.MEETING_REPORTS}>all Meeting Reports</Link>
    </Typography>
  </Stack>
);

export default NoResults;
